import axios, { CancelTokenSource } from 'axios';

import { APIError, UnsupportedStructureError } from '~services/Errors';

import { ListQueueResponseDecoder, ListQueuesResponse } from './domain';

export const getQueues = async (cancelToken?: CancelTokenSource): Promise<ListQueuesResponse | undefined> => {
  const path = `/api/routing-profiles/queues`;
  let resp;

  try {
    resp = await axios.request({
      url: path,
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
  } catch (e) {
    if (axios.isCancel(e)) {
      return undefined;
    }
    if (axios.isAxiosError(e)) {
      // Response should always be defined if axios error
      throw new APIError(e.response!.status, e.message);
    }

    throw new APIError(-1, e as string);
  }

  const decoded = ListQueueResponseDecoder.run(resp.data);

  if (decoded.ok === false) {
    const err = new UnsupportedStructureError(decoded.error.message);

    console.error(decoded.error);
    console.error(err);
    throw err;
  }

  return decoded.result;
};
